import getip from './GetIP_use'   //アクセスするAPI
import API_v1 from './api_v1_use'
const repositories = {
    //ここにリポジトリのリストを格納
    api1: getip,
    api2: API_v1
    // gets :athrtRepository
}

export const RepositoryFactory = {
    get: name => repositories[name]
}

export default RepositoryFactory
